<template>
  <v-layout row justify-center>
    <v-dialog v-model="component.destroyDialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline"
          >Deseja Excluir este item do Forma de Pagamento ?</v-card-title
        >
        <v-card-text
          >Essa ação irá excluir o item do Forma de Pagamento</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="error"
            @click="
              () => {
                executeAlterDestroyDialog(this);
              }
            "
            >Cancelar</v-btn
          >
          <v-btn
            color="success ml-4"
            @click="
              () => {
                submit();
              }
            "
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    component: Object,
    destroy_object: Function,
  },
  methods: {
    executeAlterDestroyDialog() {
      this.component.destroyDialog = false;
    },
    submit() {
      this.component.destroy_object();
    },
    getTitle() {
      return (
        (this.component.component && this.component.component.title) || "teste"
      );
    },
    
    
  },
};
</script>

<style>
</style>